export default "__VITE_IMAGE_ASSET__2dc54d89__";